import { useState, useEffect } from 'react';
import { onSnapshot, query, collection, orderBy, addDoc, updateDoc, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useContacts = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    nonLus: 0,
    lus: 0,
    archives: 0
  });

  useEffect(() => {
    const q = query(collection(db, 'contacts'), orderBy('date', 'desc'));
    
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map(doc => {
          const msgData = doc.data();
          return {
            id: doc.id,
            ...msgData,
            date: msgData.date.toDate ? msgData.date.toDate() : new Date(msgData.date)
          };
        });
        
        setMessages(data);
        
        // Calculer les stats
        setStats({
          total: data.length,
          nonLus: data.filter(m => m.statut === 'non_lu').length,
          lus: data.filter(m => m.statut === 'lu').length,
          archives: data.filter(m => m.statut === 'archive').length
        });
        
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Erreur contacts:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // Envoyer un message (depuis le formulaire public)
  const sendMessage = async (data) => {
    try {
      const messageData = {
        ...data,
        statut: 'non_lu',
        date: serverTimestamp(),
        ip: null // Pourrait être ajouté côté serveur
      };
      
      await addDoc(collection(db, 'contacts'), messageData);
      
      return { 
        success: true, 
        message: 'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.'
      };
    } catch (err) {
      console.error('Erreur envoi message:', err);
      return { success: false, error: err.message };
    }
  };

  // Marquer comme lu
  const markAsRead = async (id) => {
    try {
      const messageRef = doc(db, 'contacts', id);
      await updateDoc(messageRef, {
        statut: 'lu',
        dateLecture: serverTimestamp()
      });
      return { success: true };
    } catch (err) {
      console.error('Erreur markAsRead:', err);
      return { success: false, error: err.message };
    }
  };

  // Archiver un message
  const archiveMessage = async (id) => {
    try {
      const messageRef = doc(db, 'contacts', id);
      await updateDoc(messageRef, {
        statut: 'archive',
        dateArchivage: serverTimestamp()
      });
      return { success: true };
    } catch (err) {
      console.error('Erreur archive:', err);
      return { success: false, error: err.message };
    }
  };

  // Supprimer un message
  const deleteMessage = async (id) => {
    try {
      await deleteDoc(doc(db, 'contacts', id));
      return { success: true };
    } catch (err) {
      console.error('Erreur suppression:', err);
      return { success: false, error: err.message };
    }
  };

  return {
    messages,
    loading,
    error,
    stats,
    sendMessage,
    markAsRead,
    archiveMessage,
    deleteMessage
  };
};

// Statuts des messages
export const STATUTS_MESSAGE = {
  non_lu: { label: 'Non lu', color: '#DC2626', bg: '#FEE2E2' },
  lu: { label: 'Lu', color: '#3B82F6', bg: '#DBEAFE' },
  archive: { label: 'Archivé', color: '#6B7280', bg: '#F3F4F6' }
};

// Sujets prédéfinis
export const SUJETS_CONTACT = [
  { value: 'information', label: 'Demande d\'information' },
  { value: 'plainte', label: 'Réclamations' },
  { value: 'suggestion', label: 'Suggestion' },
  { value: 'partenariat', label: 'Partenariat' },
  { value: 'mediation', label: 'Demande de médiation' },
  { value: 'autre', label: 'Autre' }
];

